import { React, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import "./index.scss";

import FileUpload from "../../../ui/FileUpload";
import Button from "../../../ui/Button";
import DropDown from "../../../ui/DropDown";
import RadioButton from "../../../ui/RadioButton";

import { getloggedInUserType } from "../../../../utils/util";

import { useDispatch, useSelector } from 'react-redux';
import { updateDomainDetails } from '../../../../store/actions/domainAction';

const EditDomainModal = ({domainData, cancelEditDoamin}) => {

    const serverListResposne = useSelector((state) => state?.domain?.serverList)

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [files, setFiles] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [fileObject, setFileObject] = useState(null);
    const [serverList, setServerList] = useState([]);
    const [selectedOrganization, setSelectedOrganization] = useState("");
    const [domainType, setDomainType] = useState("");

    const getUploadfile = (file) => {
        setFiles(file)
    }

    const handleSelectOrganization = (value) => {
        setSelectedOrganization(value)
    }

    const saveDetails = () =>{
        let obj = {
            domain: domainData.domain,            
            logo_delete: false,
        }
        const isValidBase64 = /^(data:image\/[a-zA-Z]+;base64,)?([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
        if(files && isValidBase64.test(files)) {
            obj.logo = files
        }
        if(files === "") {
            obj.logo_delete = true
        }
        if(getloggedInUserType() === "internal") {            
            obj.scan_from = selectedOrganization.id
        }
        if(getloggedInUserType() === "customer" && domainType !== "") {
            obj.domain_type = domainType;
        }
        setIsLoading(true)
        dispatch(updateDomainDetails(obj))
        if (files && isValidBase64.test(files)) {
            setFiles(null); // Reset the files state to avoid reprocessing
        }
    }

    useEffect(()=>{
        setFiles(domainData?.logo || "");
        let obj = {
            name: domainData.domain,
            logo: domainData.logo
        }
        setFileObject(obj)
        if(getloggedInUserType() === "customer") {
            setDomainType(domainData?.domain_type)
        }
            
    },[domainData])

    useEffect(()=>{
        if(serverListResposne !== null) {
            let list = serverListResposne?.servers?.map((data)=>{
                return {
                    id: data.value,
                    name: data.name,
                    value: data.value,
                    logo: data.name,
                    label: data.name
                }
            })
            setServerList(list)
            setSelectedOrganization(domainData.scan_from !== null ? domainData.scan_from : "")
        }
    },[serverListResposne, domainData])

    return (
        <div className="add-organization-container">  
            <div className="modal-header mt-4">
                <h2>{t("domainPage.editDomainModal.editDomain")}</h2>
            </div>
            <div className="add-organization-step-one mt-3">
                <FileUpload onFilesSelected={getUploadfile} label={'Upload an Avatar'} filePath={files} place="editDomain" fileObject={fileObject}/>
                {getloggedInUserType() === "internal" && <div className="input-container mt-4 organization-select-domainPage">
                            <label>Scan from which Server</label>
                            <DropDown
                                options={serverList}
                                placeHolder='Please select Server'
                                onChange={(e) => handleSelectOrganization(e)}
                                isSearchable = {true}
                                dropDownType = {'addDomain'}
                                defaultSelectedValue={selectedOrganization}
                            />
                        </div>
                }
                {getloggedInUserType() === "customer" && 
                    <>                        
                        <div className="organization-type mt-4">
                            <p>Domain Type</p>
                            <div className="radio-btn-group d-flex mt-3">
                                <div className="domain-type d-flex align-items-center gap-1">
                                    <RadioButton radioId={'internal'} radioLabel={'Internal'} radioValue={'internal'} onChange={(value)=>{setDomainType(value)}}  isChecked={domainType === 'internal'}/>                                    
                                </div>
                                <div className="domain-type d-flex align-items-center gap-1">
                                    <RadioButton radioId={'portfolio'} radioLabel={'Portfolio'} radioValue={'portfolio'} onChange={(value)=>{setDomainType(value)}} isChecked={domainType === 'portfolio'}/>                                    
                                </div>
                                <div className="domain-type d-flex align-items-center gap-1">
                                    <RadioButton radioId={'thirdParty'} radioLabel={'Third Party'} radioValue={'third_party'} onChange={(value)=>{setDomainType(value)}} isChecked={domainType === 'third_party'}/>                                    
                                </div> 
                            </div>
                        </div> 
                    </>
                }
            </div>
            <div className="form-submit-btn-group mt-4">
                <Button buttonText={"Cancel"} buttonType="secondary" buttonClicked={cancelEditDoamin}/>
                {!isLoading && <Button buttonText={"Save"} buttonType="primary" buttonClicked={saveDetails} disableButton={getloggedInUserType() === "internal" ? selectedOrganization === "" : false}/>}
                {isLoading && <Button buttonText={"Loading..."} buttonType="primary" disableButton={true} />}
            </div>
        </div>
    )
}

export default EditDomainModal;